<template>
	<nut-navbar
		class="navbar"
		title="等待支付"
		leftShow
		@on-click-back="goBack"
	></nut-navbar>
	<div class="container">
		<div class="row">
			<span class="label">付款金额</span>
			<span class="val money">{{
				payData.fee ? `${payData.fee / 100}元` : ''
			}}</span>
		</div>
		<div class="row">
			<span class="label">商品</span>
			<span class="val">{{ payData.title }}</span>
		</div>
		<div class="row">
			<span class="label">描述</span>
			<span class="val">{{ payData.desc }}</span>
		</div>
		<div class="btn" @click="handleWxPay">
			<span>立即支付</span>
		</div>
	</div>
</template>

<script>
/* eslint-disable */
import { ref, onMounted } from 'vue';
import { Toast } from '@nutui/nutui';
import useNavigate from '@/hooks/useNavigate';
import wx from 'weixin-js-sdk';
import { useRoute } from 'vue-router';
import { wxpayApi } from '@/apis';
import { getConfigUrl } from '@/utils/util';

export default {
	name: 'DevfeePay',
	setup() {
		const { goBack, push } = useNavigate();
		const route = useRoute();
		const payData = ref({});
		const getPayData = async () => {
			const paymentid = route.query.paymentid;
			const url = getConfigUrl();
			//待验证
			const res = await wxpayApi.wxpay_load_data({
				wx_payment_id: paymentid,
				url,
			});
			payData.value = res;
			console.log(res);

			// 从paydata 中取config的参数
			wx.config({
				debug: res.signpackage.debug,
				appId: res.signpackage.appId,
				timestamp: res.signpackage.timestamp,
				nonceStr: res.signpackage.nonceStr,
				signature: res.signpackage.signature,
				jsApiList: res.signpackage.jsApiList,
			});
		};

		// 上报处理
		const notice = async (params, cb) => {
			await wxpayApi.wxpay_paid(params);
			cb && cb();
		};

		const handleWxPay = () => {
			const paymentid = route.query.paymentid;
			const { payparams } = payData.value;

			// ///////////////////////////////////////////////////////////
			// notice(
			// 		{
			// 			wx_payment_id: 727,
			// 			result: 'success',
			// 			err_msg: 'chooseWXPay:ok',
			// 		},
			// 		() => {
			// 			Toast.text('支付成功', {
			// 				duration: 1000,
			// 				onClose: () => {
			// 					push('/home');
			// 				},
			// 			});
			// 		}
			// 	);
			// ///////////////////////////////////////////////////////////

			wx.chooseWXPay({
				timestamp: payparams.timestamp,
				nonceStr: payparams.nonceStr,
				package: payparams.package,
				signType: payparams.signType,
				paySign: payparams.paySign,
				success: (res) => {
					if (res.errMsg == 'chooseWXPay:ok') {
						notice(
							{
								wx_payment_id: paymentid,
								result: 'success',
								err_msg: res.errMsg,
							},
							() => {
								Toast.text('支付成功', {
									duration: 1000,
									onClose: () => {
										push('/home');
									},
								});
							}
						);
					} else if (res.errMsg == 'chooseWXPay:fail') {
						notice({
							wx_payment_id: paymentid,
							result: 'fail',
							err_msg: res.errMsg,
						});
					}
				},
				cancel: (res) => {
					Toast.text('支付取消');
					notice({
						wx_payment_id: paymentid,
						result: 'cancel',
						err_msg: res.errMsg,
					});
				},
				fail: (err) => {
					Toast.text(err.message || '支付失败');
					notice({
						wx_payment_id: paymentid,
						result: 'fail',
						err_msg: err.errMsg,
					});
				},
			});
		};

		onMounted(() => {
			getPayData();
		});

		return {
			payData,

			goBack,
			handleWxPay,
		};
	},
};
</script>

<style lang="scss" scoped>
.container {
	.row {
		@include flex-center;
		position: relative;
		margin: 0 16px;
		padding: 10px 0;
		min-height: 32px;
		&::after {
			@include hairline-bottom;
		}
		.label,
		.val {
			color: #999;
			font-size: 12px;
			text-align: right;
		}
		.label {
			margin-right: 20px;
		}

		.val {
			flex: 1;
		}

		.money {
			font-size: 18px;
			font-weight: 500;
			color: #333;
		}
	}

	.btn {
		&::after {
			@include hairline-bottom;
		}
		position: relative;
		padding: 12px 0;
		line-height: 40px;
		margin: 0 16px;
		text-align: center;
		color: #0bb20c;
		font-size: $large-font-size;
	}
}
</style>
